import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Avatar,
  Radio,
  Divider,
  message,
  Modal,
  Input,
  Button,
  Form,
  Tag,
} from "antd";
import SubLayout from "../../components/layout/SubLayout";
import ReactPlayer from "react-player";

import { DownloadOutlined, UserOutlined, StarOutlined, StarFilled } from "@ant-design/icons";
import MailICon from "../../Assets/profile/mail.svg";
import CheckMark from "../../Assets/profile/checkMark.svg";
import PhoneIcon from "../../Assets/profile/phone.svg";
import AddressIcon from "../../Assets/profile/address.svg";
import DocumentBox from "../../components/common/DocumentBox";
import JobPositionCard from "../../components/common/campaignManagement/JobPositionCard";
import JobPositionCardGrouped, {
  groupExperiences,
} from "../../components/common/campaignManagement/JobPositionCardGrouped";
import { USE_GROUPED_JOB_EXPERIENCE } from "../../components/common/campaignManagement/jobExperienceUi";
import { UpdateApplicantProfileStatus } from "../../components/common/Popup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import API_MANAGER from "../../API";
import moment from "moment";
import { jobStatusEnum } from "../../utils";
import FullScreenLoader from "../../components/common/FullScreenLoader";
import InviteCampaignDropdown from "../../components/common/search/InviteCampaignDropdown";
import ApplicantChatDrawer from "../../components/common/campaignManagement/ApplicantChatDrawer";
import { UpdatestatusPopup } from "../../components/common/AdvertDetail/Reportpopup";
import { Tooltip } from "antd";
import { baseURL } from "../../API/index";
import Cookies from "js-cookie";
import thumbnail from "../../../src/Assets/thumbnail.jpeg";

function ApplicantProfile() {
  const navigate = useNavigate();
  const [type, setType] = useState("PE");
  const [citizen, setCitizen] = useState("");
  const [loading, setLoading] = useState(false);
  const [updateStatusModal, setUpdateStatusModal] = useState(false);
  const [candidateData, setCandidateData] = useState();
  console.log(candidateData,"CCDA")
  const [soaOpen, setSoaOpen] = useState(false);
  const [vocOpen, setVocOpen] = useState(false);
  const [candidateProgress, setCandidateProgress] = useState("");
  const [isHidden, setIsHidden] = useState(true);
  const [inviteModal, setInviteModal] = useState(false);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [campaignSearch, setCampaignSearch] = useState(null);
  const [campaignList, setCampaignList] = useState([]);
  const [inviteIds, setInviteIds] = useState({});
  const [updatePopup, setUpdatePopup] = useState(false);
  const [candidateSelectedData, setCandidateSelectedData] = useState({});
  const [isFavorite, setIsFavorite] = useState(false);
  const [favoriteLoading, setFavoriteLoading] = useState(false);
  const [askLoading, setAskLoading] = useState(false);
  const userType = localStorage.getItem("user");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chatDrawerOpen, setChatDrawerOpen] = useState(false);
  
  const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
  const hasAllPermissions = [0, 1, 2, 3, 4, 5].every(perm => permissions.includes(perm));
  const [notify, setNotify] = useState(false);
  const [ticketType, setTicketType] = useState(null);
  const [ticketId, setTicketId] = useState(null);
  const [notificationHeading, setNotificationHeading] = useState("");
  const [form1] = Form.useForm();

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);
  const location= useLocation();
  const previousCurrentPage = location.state?.previousCurrentPage || 'campaign-management';

   const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    setIsPlaying(!isPlaying);
  };

  // const thumbnail =
  //   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTq2BMsIzmxvAw16YQ-cLSe-4-qa-j_iEUlwQ&s";

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { id } = useParams();
  const { state } = useLocation();
  const props = state;
  const withDrawlCandidate = state?.withDrawlCandidate;
  const isViewable=state?.isViewable;
  const cameFromHyperlink = !state;


  //CHECKING JOB STATE FROM ADVERT ID

  const singleUserCampaignDetails = async () => {
    const param = {
        profileId: candidateData?.candidate?.id,
      search: campaignSearch ? campaignSearch : "",
      sort: "-createdAt",
      limit: 20000,
      page: 1,
    };
    try {
      const response = await API_MANAGER.getSingleUserCampaignDetails(
        param,
        localStorage.getItem("userID")
      );
      setCampaignList(response?.data?.data);
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  const DownloadDocs = async () => {
    try {
      const apiEndpoint = `${baseURL}details/download-details/${id}`;

      const authToken = Cookies.get("access_token");

      const response = await fetch(apiEndpoint, {
        method: "GET",

        headers: {
          Authorization: `Bearer ${authToken}`,

          "Content-Type": "application/json",
        },

        mode: "cors",
      });

      console.log(response, "AFTER xxx");

      const contentDisposition = response.headers.get("Content-Disposition");

      let filename = "details.zip";

      console.log(contentDisposition);

      if (contentDisposition && contentDisposition.includes("filename=")) {
        filename = contentDisposition
          .split("filename=")[1]
          .replace(/"/g, "")
          .trim();
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");

      a.style.display = "none";

      a.href = url;

      a.download = filename;

      document.body.appendChild(a);

      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the ZIP file:", error);
    }
  };

  useEffect(() => {
    // Get advertId from props or state
    const advertId = props?.id || props?.advertId || state?.advertId || state?.id;
    
    if (advertId && candidateData?.candidate?.appliedJobs) {
      const appliedJobData = candidateData.candidate.appliedJobs.find(
        (jobs) => {
          const jobAdvertId = jobs?.advertId?.id || jobs?.advertId?._id;
          return jobAdvertId === advertId || jobAdvertId === String(advertId);
        }
      );

      setCandidateSelectedData(appliedJobData || { isInvited: true });
      
      // Find the highest state in the progress array (not just the last one)
      let applicationState = -1;
      if (appliedJobData && appliedJobData.progress && Array.isArray(appliedJobData.progress) && appliedJobData.progress.length > 0) {
        // Get all states from progress array and filter valid ones
        const states = appliedJobData.progress
          .map(p => p?.state)
          .filter(state => state !== null && state !== undefined && state !== -1 && typeof state === 'number');
        
        if (states.length > 0) {
          // Find the highest state (0=APPLIED, 1=ACCEPTED, 2=SHORTLIST_OFFERED, 3=HARD_REVIEW, 4=ROLE_OFFERED, 5=ROLE_ACCEPTED)
          applicationState = Math.max(...states);
        }
      }
      
      if (applicationState > 2 || isViewable ) {
        setIsHidden(false);
      }
      
      // Map state to status label using ApplicationProgressEnum
      if (applicationState !== -1 && applicationState !== undefined && applicationState >= 0 && applicationState <= 5) {
        const applicantStatus = jobStatusEnum[applicationState];
        setCandidateProgress(applicantStatus?.label || "INVITED");
      } else {
        setCandidateProgress("INVITED");
      }
    } else if (!advertId && candidateData) {
      // If no advertId provided, show INVITED
      setCandidateProgress("INVITED");
      setCandidateSelectedData({ isInvited: true });
    }
  }, [props, candidateData, id, isViewable, state]);

  useEffect(() => {
    if ((props?.search || withDrawlCandidate === "yes") && candidateData) {
      singleUserCampaignDetails();
    }
  }, [props, candidateData, campaignSearch]);
  useEffect(() => {
    const hasVisaDocument = candidateData?.candidate?.documents?.some(
      (doc) => doc?.documentType?.name === "VISA"
    );
    if (hasVisaDocument) {
      setCitizen("Non - Australian Citizen");
    } else {
      setCitizen("australian");
    }
  }, [candidateData]);

  

  //GETTING CANDIDATE DATA
  const getCandidateDetails = async () => {
    setLoading(true);
    try {
      const response = await API_MANAGER.getAppliedCandidateDetails(id);
      // setCandidatesDetails(response?.data?.data?.result);
   
      setCandidateData(response?.data?.data);
      
      // Set isHidden based on API response
      // If API returns isHidden: false, content should be visible (not blurred)
      // If API returns isHidden: true, content should be blurred
      if (response?.data?.data?.isHidden !== undefined) {
        // setIsHidden(response?.data?.data?.isHidden);
      }
      
      setLoading(false);
      
      // Check favorite status after candidate data is loaded
      if (response?.data?.data?.candidate?._id) {
        await checkFavoriteStatus(response?.data?.data?.candidate?._id);
      }
    } catch (error) {
      message.error("Something went wrong. Please try again.");
      setLoading(false);
    }
  };
  useEffect(() => {
    getCandidateDetails();
  }, [id]);


const handleAsk = async () => {
  
  if (!id) return; 
  setAskLoading(true);
  try {
    if (state?.id) {
    
      await API_MANAGER.introVideoNotification(id, state.id);
    } else {
     
      await API_MANAGER.introVideoNotification(id);
    }
    message.success("Request sent.");
  } catch (err) {
    message.error("Failed to send request.");
  } finally {
    setAskLoading(false);
  }
};



  // Check if candidate is in favorites
  const checkFavoriteStatus = async (candidateId) => {
    try {
      const response = await API_MANAGER.getAllFavourites();
      const favorites = response?.data?.data || [];
      
      // Check if current candidate is in the favorites list
      // The API returns objects with candidateId containing the full candidate object
      const isInFavorites = favorites.some(fav => 
        fav.candidateId?._id === candidateId || 
        fav.candidateId?.id === candidateId
      );
      
      setIsFavorite(isInFavorites);
    } catch (error) {
      console.error("Error checking favorite status:", error);
    }
  };


  const handleStatementOfAttainment = () => {
    if (soaOpen) setSoaOpen(false);
    else setSoaOpen(true);
  };
  const handleVOC = () => {
    if (vocOpen) setVocOpen(false);
    else setVocOpen(true);
  };
  const replaceString = (string) => {
    if (typeof string === "number") {
      string = string?.toString();
    }
    return string?.replace(/[^\s]/g, "x");
  };
  const handleOk = async () => {
    setInviteLoading(true);
    let tempInvites = Object.entries(inviteIds);
    let adverts = [];
    tempInvites?.map((item) => {
      item[1]?.map((e) => {
        adverts.push({
          advertId: e,
          campaignId: item[0],
        });
      });
    });
    const params = {
      adverts: adverts,
      profileId: candidateData?.candidate?._id,
    };
    try {
      const response = await API_MANAGER.inviteUsers(params);
      setInviteLoading(false);
      message.success("Candidate successfully invited.");
      setInviteModal(false);
      // GetGlobalSearch();
      // navigate(`/applicant-profile/${candidateData?._id}`, {
      //   state: { isInvited: true, search: true },
      // });
      navigate(-1);
    } catch (error) {
      setInviteLoading(false);
      message.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
    }
  };
  const backUrlFunction = () => {
    // If coming from Chat, navigate back to chat screen
    if (state?.fromChat) {
      navigate(`/chats`, {
        state: {
          selectedChat: state?.selectedChat,
          chatId: state?.chatId,
        },
      });
      return;
    }
    // If coming from Tracker, navigate back to tracker screen
    if (state?.fromTracker && state?.id) {
      // Get current filter from sessionStorage if not in state (fallback)
      const currentFilter = state?.filterType !== undefined 
        ? state.filterType 
        : (() => {
            try {
              const saved = sessionStorage.getItem(`trackerFilter_${state?.id}`);
              return saved ? JSON.parse(saved) : undefined;
            } catch {
              return undefined;
            }
          })();
      
      navigate(`/advert-tracker/${state?.id}`, {
        state: {
          currentPage: state?.currentPage || 1,
          search: state?.search !== undefined ? state.search : undefined, // Pass search if it was provided
          tabType: state?.tabType !== undefined ? state.tabType : undefined, // Preserve tab type
          filterType: currentFilter !== undefined ? currentFilter : undefined, // Preserve filter selection (including empty array)
          fromAdvertDetail: true, // We're coming from AdvertDetail originally
          // Preserve original source info
          campaignId: state?.campaignId,
          fromCampaignDetail: state?.fromCampaignDetail,
          originalSource: state?.originalSource
        },
        replace: true // Replace to prevent extra history entries
      });
    }
    // If coming from MobilisationManagement, navigate back with preserved pagination and filters
    else if (state?.fromMobilisation && state?.currentPage !== undefined) {
      navigate(`/mobilisation-management`, {
        state: {
          currentPage: state?.currentPage,
          filterState: state?.filterState || {},
        },
      });
    } 
    // If coming from AdvertDetail, navigate back with preserved pagination
    else if (state?.id && state?.currentPage !== undefined && !state?.fromMobilisation && !state?.fromTracker) {
      navigate(`/advert-detail/${state?.id}`, {
        state: {
          currentPage: state?.currentPage,
          fromApplicantProfile: true,
          originalSource: state?.originalSource || 'campaign-management',
          campaignId: state?.campaignId,
          fromCampaignDetail: state?.originalSource === 'campaign-detail',
          fromJobAdvert: state?.fromJobAdvert,
        },
        replace: true
      });
    } 
    // If coming from Global Search, navigate back with preserved filters, search, and pagination
    else if (state?.search || state?.isBackFunc) {
      const encodedSearch = (state?.searchText || "").split(" ").join("%20");
      const searchUrl = `/search?search=${encodedSearch}&page=${state?.page || 1}${
        state?.tab === "favourites" ? "&tab=favourites" : ""
      }`;
      navigate(searchUrl, {
        state: {
          page: state?.page || 1,
          filter: state?.filter || {},
          searchText: state?.searchText || "",
          tab: state?.tab,
          path: state?.path,
        },
      });
    } else {
      // Fallback: navigate to search page
      navigate(`/search?search=${state?.searchText || ""}&page=${state?.page || 1}`, {
        state: {
          page: state?.page || 1,
          filter: state?.filter || {},
          search: state?.searchText || "",
          path: state?.path,
        },
      });
    }
  };
  const toggleFavorite = async () => {
    setFavoriteLoading(true);
    try {
      if (isFavorite) {
        // Remove from favorites
        await API_MANAGER.removeFavourite(candidateData?.candidate?._id);
        // message.success("Removed from favorites");
        setIsFavorite(false);
      } else {
        // Add to favorites
        await API_MANAGER.addFavourite({ candidateId: candidateData?.candidate?._id });
        // message.success("Added to favorites");
        setIsFavorite(true);
      }
    } catch (error) {
      message.error("Failed to update favorite status.");
    } finally {
      setFavoriteLoading(false);
    }
  };

  const handleNotify = async (values) => {
    try {
      let messageText = values.message || "";
      
      if (messageText) {
        const lines = messageText.split('\n');
        const processedLines = lines.map((line, index) => {
          const isLastLine = index === lines.length - 1;
          const isEmptyLastLine = isLastLine && line === '';
          
          if (line.trim() && !isEmptyLastLine) {
            if (!isLastLine) {
              return `<b>${line.trim()}</b>`;
            }
          }
          return line;
        });
        messageText = processedLines.join('\n');
      }
      
      const finalMessageText = notificationHeading 
        ? `<b>${notificationHeading}</b>\n${messageText}` 
        : messageText;
      
      values.profileId = candidateData?.candidate?._id;
      values.type = "CUSTOM";
      values.ticketType = ticketType;
      values.ticketId = ticketId;
      values.message = finalMessageText;
      values.userId=id;
      values.recruiterId=localStorage.getItem("clientId");
      await API_MANAGER.sendNotification(values);
      form1.resetFields();
      setTicketType(null);
      setTicketId(null);
      setNotificationHeading("");
      setNotify(false);
      message.success("Notification successfully sent.");
    } catch {
      message.error("Something went wrong!");
    }
  };

  const updateCandidateJobStatus = async () => {
    try {
      const currentState = candidateSelectedData?.progress?.[
        candidateSelectedData?.progress?.length - 1
      ]?.state;
      
      // Recruiter actions: Can offer Shortlist from state 0, and offer Role from state 3
      if (currentState === 0 || currentState === "0" || Number(currentState) === 0) {
        // Recruiter can offer Shortlist from Applied state
        await API_MANAGER.updateCandidateJobStatus(candidateSelectedData?._id, {
          status: "SHORTLIST_OFFERED",
        });
      } else if (
        candidateSelectedData?.progress[
          candidateSelectedData?.progress?.length - 1
        ]?.state === 2
      ) {
        // Candidate action: Accept Shortlist Offer (state 2 → 3)
        // This should be done by candidate, but recruiter can trigger it
        await API_MANAGER.acceptShortlistOffer({
          applicationId: candidateSelectedData?._id,
          acceptance: true,
        });
      } else if (
        candidateSelectedData?.progress[
          candidateSelectedData?.progress?.length - 1
        ]?.state === 3
      ) {
        // Recruiter action: Offer Role from Hard Review state
        await API_MANAGER.updateCandidateJobStatus(candidateSelectedData?._id, {
          status: "ROLE_OFFERED",
        });
      } else {
        // Invalid state transition
        setUpdatePopup(false);
        return;
      }

      message.success("Status successfully updated.");
      setUpdatePopup(false);
      getCandidateDetails();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "A Candidate must accept your previous request, before you can push them to the next stage of the recruitment process."
      );
      setUpdatePopup(false);
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .ask-btn {
            background: #ffcf3f;
            border: none;
            color: #071135;
            font-weight: 700;
            border-radius: 12px;
            height: 40px;
            padding: 0 18px;
            display: inline-flex;
            align-items: center;
            gap: 8px;
          }
          .ask-btn:hover,
          .ask-btn:focus {
            background: #f2c22e;
            color: #071135;
          }
          .ask-btn[disabled],
          .ask-btn[aria-disabled='true'] {
            background: #f7df7a !important;
            color: #071135 !important;
            opacity: 0.9;
          }
          .ask-icon { display: inline-flex; }
        `}
      </style>
      <SubLayout
      page="Applicant Profile"
      whiteBg
      showBack={!cameFromHyperlink}
      showSearch
      backUrlFunction={backUrlFunction}
      isBackFunc={state?.isBackFunc || state?.id || state?.fromMobilisation || state?.fromTracker}
      currentPage={previousCurrentPage}
    >
      <FullScreenLoader isLoading={loading} />{" "}
      {/* {candidateSelectedData?.progress?.[
        candidateSelectedData?.progress?.length - 1
      ]?.state <= 4 ? ( */}
      <UpdatestatusPopup
        updatePopup={updatePopup}
        setUpdatePopUp={setUpdatePopup}
        setUpdatePopup={setUpdatePopup}
        candidateSelectedData={candidateSelectedData}
        onSubmit={updateCandidateJobStatus}
        name={candidateData?.candidate?.name}
      />
      {/* ) : null} */}
      <Modal
        title={`Invite ${props?.name || candidateData?.candidate?.name} to:`}
        open={inviteModal}
        onOk={handleOk}
        onCancel={() => setInviteModal(false)}
        okText={"Invite"}
        wrapClassName="invite-modal"
        centered
        getContainer={document.body}
        confirmLoading={inviteLoading}
         zIndex={999999}
      >
        <Input
          className="search-input mb-20"
          size="large"
          placeholder="Select or search adverts"
          value={campaignSearch}
          onChange={(e) => setCampaignSearch(e?.target?.value)}
          prefix={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
            >
              <path
                d="M19.8947 19.0002L15.5517 14.6572M15.5517 14.6572C16.2946 13.9143 16.8839 13.0324 17.286 12.0618C17.688 11.0911 17.8949 10.0508 17.8949 9.00021C17.8949 7.9496 17.688 6.90929 17.286 5.93866C16.8839 4.96803 16.2946 4.08609 15.5517 3.34321C14.8088 2.60032 13.9269 2.01103 12.9563 1.60898C11.9857 1.20693 10.9453 1 9.89474 1C8.84414 1 7.80382 1.20693 6.83319 1.60898C5.86256 2.01103 4.98062 2.60032 4.23774 3.34321C2.73741 4.84354 1.89453 6.87842 1.89453 9.00021C1.89453 11.122 2.73741 13.1569 4.23774 14.6572C5.73807 16.1575 7.77295 17.0004 9.89474 17.0004C12.0165 17.0004 14.0514 16.1575 15.5517 14.6572Z"
                stroke="#1638B1"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
        />
        <div className="campaignListContainer">
          {campaignList &&
            campaignList?.map((item, index) => (
              <InviteCampaignDropdown
                setInviteIds={setInviteIds}
                inviteIds={inviteIds}
                item={item}
                key={index}
              />
            ))}
        </div>
      </Modal>
      <ApplicantChatDrawer
        open={chatDrawerOpen}
        onClose={() => setChatDrawerOpen(false)}
        memberId={
          candidateData?.candidate?.userId ||
          candidateData?.userId ||
          id
        }
        candidateName={
          candidateData?.candidate?.name || props?.name || ""
        }
        candidateImage={candidateData?.candidate?.profileImage}
      />
      <div className="applicant_profile_main_container">
        {/* for small screen only */}
        {!cameFromHyperlink && (
          <Row>
            <Col xs={24} md={0}>
              <p className="profile-goback" onClick={() => navigate(-1)}>
                {"< Applicant Profile"}
              </p>
            </Col>
          </Row>
        )}
        <Row gutter={[20, 20]}>
          <Col xs={24} md={7}>
            <div className="personal_detail_container">
              <Row justify={"space-between"}>
                <Col
                  xs={7}
                  md={24}
                  className="align-center-justify avatar-icon "
                  style={{ position: "relative", marginTop: "8px" ,marginBottom:"10px"}}
                >
                  {!isHidden ? (
                    <Avatar
                      icon={<UserOutlined />}
                      size={window.innerWidth > 767 ? 122 : 84}
                      className="avatar-icon"
                      src={candidateData?.candidate?.profileImage}
                    />
                  ) : (
                    <Avatar
                      icon={<UserOutlined />}
                      size={window.innerWidth > 767 ? 122 : 84}
                      src={candidateData?.candidate?.profileImage}
                      className="avatar-icon text_blur"
                    />
                  )}
                  {userType !== "Associate" && (
                  <Tooltip title={isFavorite ? "Remove from favourite" : "Click to mark as favourite"}>
                    <div
                      onClick={toggleFavorite}
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-8px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        backgroundColor: "white",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                        transition: "all 0.2s ease",
                        zIndex: 10,
                      }}
                    >
                      {isFavorite ? (
                        <div
                          style={{
                            width: "18px",
                            height: "18px",
                            borderRadius: "50%",
                            backgroundColor: "#facc15",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "18px",
                            height: "18px",
                            borderRadius: "50%",
                            border: "1.5px solid #666",
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                              stroke="#666"
                              strokeWidth="1.5"
                              fill="none"
                            />
                          </svg>
                        </div>
                      )}
                    </div>
                  </Tooltip>
                  )}
                </Col>
                <Col xs={16} md={24}>
                  {props?.search || withDrawlCandidate === "yes" ? (
                    <>
                      <div
                        className="tagBox cursor-pointer"
                        style={{ padding: "0px 16px", width: "fit-content", margin: "0 auto" }}
                        onClick={() => {
                          setInviteModal(true);
                        }}
                      >
                        <Row gutter={8} justify={"center"} align={"middle"}>
                          <Col>
                            <svg
                              width="8"
                              height="7"
                              viewBox="0 0 8 7"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.18342 5.28999C4.97579 6.49159 3.02421 6.49159 1.81658 5.28999C-0.141075 3.34213 1.23838 0 4 0C6.76162 0 8.14108 3.34213 6.18342 5.28999Z"
                                fill="#071135"
                              />
                            </svg>
                          </Col>
                          <Col>INVITE</Col>
                        </Row>
                      </div>
                    </>
                  ) : (
                    <div
                      className={`tagBox ${
                        userType !== "Associate" && "cursor-pointer"
                      }`}
                      style={{ padding: "0px 16px", width: "fit-content", margin: "0 auto", marginTop:"20px" }}
                      onClick={() => {
                        userType !== "Associate" && setUpdatePopup(true);
                      }}
                    >
                      <Row gutter={8} justify={"center"} align={"middle"}>
                        <Col>
                          <svg
                            width="8"
                            height="7"
                            viewBox="0 0 8 7"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.18342 5.28999C4.97579 6.49159 3.02421 6.49159 1.81658 5.28999C-0.141075 3.34213 1.23838 0 4 0C6.76162 0 8.14108 3.34213 6.18342 5.28999Z"
                              fill="#071135"
                            />
                          </svg>
                        </Col>
                        <Col>{candidateProgress}</Col>
                      </Row>
                    </div>
                  )}
                  <p className="name" style={{ textTransform: "capitalize" }}>{candidateData?.candidate?.name}</p>
                    <div style={{ marginTop: "0px", textAlign: "center", marginBottom: "6px" }}>
                      {candidateData?.candidate?.documents?.some(
                        (doc) => doc?.documentType?.name === "VISA"
                      ) ? (
                        <Tag 
                          color="orange" 
                          style={{ 
                            fontSize: "14px", 
                            padding: "4px 12px",
                            borderRadius: "6px",
                            fontWeight: 700,
                            margin: 0,
                            color: "#d46b08"
                          }}
                        >
                          Non-Australian
                        </Tag>
                      ) : (
                        <Tag 
                          color="orange" 
                          style={{ 
                            fontSize: "14px", 
                            padding: "4px 12px",
                            borderRadius: "6px",
                            fontWeight: 700,
                            margin: 0,
                            color: "#d46b08"
                          }}
                        >
                          Australian/New Zealand
                        </Tag>
                      )}
                    </div>
                </Col>
              </Row>

              {/* ******************************** */}
              <Row justify={"space-between"}>
                <Col xs={11} md={24}>
                  <div className="detail_box">
                    <Row gutter={8} align={"middle"} justify={"start"}>
                      <Col>
                        <img src={MailICon} />
                      </Col>
                      <Col>
                        <p className="item">Email</p>
                      </Col>
                    </Row>
                    <Row>
                      <p className="value">{candidateData?.email || "----"}</p>
                    </Row>
                  </div>
                </Col>
                <Col xs={11} md={24}>
                  <div className="detail_box">
                    <Row gutter={8} align={"middle"}>
                      <Col>
                        <img src={PhoneIcon} />
                      </Col>
                      <Col>
                        <p className="item">Phone Number</p>
                      </Col>
                    </Row>
                    <Row>
                      <p className="value">
                        {candidateData?.candidate?.countryCode || candidateData?.candidate?.phoneNumber
                          ? `+${candidateData?.candidate?.countryCode || ""} ${candidateData?.candidate?.phoneNumber || ""}`.trim()
                          : "----"}
                      </p>
                    </Row>
                  </div>
                </Col>
                <Col xs={11} md={24}>
                  <div className="detail_box">
                    <Row gutter={8} align={"middle"}>
                      <Col>
                        <img src={AddressIcon} />
                      </Col>
                      <Col>
                        <p className="item">Address</p>
                      </Col>
                    </Row>
                    <Row>
                      {!isHidden ? (
                        <p className="value">
                          {candidateData?.candidate?.street || candidateData?.candidate?.city || candidateData?.candidate?.state || candidateData?.candidate?.postalCode || candidateData?.candidate?.country
                            ? `${candidateData?.candidate?.street?.charAt(0)?.toUpperCase() || ""}${candidateData?.candidate?.street?.substring(1) || ""}${candidateData?.candidate?.street ? ", " : ""}${candidateData?.candidate?.city || ""}${candidateData?.candidate?.city ? ", " : ""}${candidateData?.candidate?.state || ""}${candidateData?.candidate?.state ? ", " : ""}${candidateData?.candidate?.postalCode || ""}${candidateData?.candidate?.postalCode ? ", " : ""}${candidateData?.candidate?.country || ""}`.replace(/,\s*$/, "").replace(/^,\s*/, "")
                            : "----"}
                        </p>
                      ) : (
                        <p>
                          <span className="value text_blur">
                            {replaceString(candidateData?.candidate?.street) || "----"}
                          </span>
                          <span className="value ">
                            {candidateData?.candidate?.city || candidateData?.candidate?.state || candidateData?.candidate?.postalCode || candidateData?.candidate?.country
                              ? `, ${candidateData?.candidate?.city || ""}, ${candidateData?.candidate?.state || ""}, ${candidateData?.candidate?.postalCode || ""}, ${candidateData?.candidate?.country || ""}`.replace(/,\s*$/, "").replace(/^,\s*/, "")
                              : ""}
                          </span>
                        </p>
                      )}
                    </Row>
                  </div>
                </Col>
                <Col xs={11} md={24}>
                  <div className="detail_box">
                    <p className="item">D.O.B</p>
                    {!isHidden ? (
                      <p className="value">
                        {candidateData?.candidate?.dob
                          ? moment(candidateData?.candidate?.dob).format("DD MMM YYYY")
                          : "----"}
                      </p>
                    ) : (
                      <p className="value text_blur">
                        {candidateData?.candidate?.dob
                          ? replaceString(moment(candidateData?.candidate?.dob).format("DD MMM YYYY"))
                          : "----"}
                      </p>
                    )}
                  </div>
                </Col>
                <Col xs={11} md={24}>
                  <div className="detail_box">
                    <p className="item">Gender</p>

                    {!isHidden ? (
                      <p className="value">
                        {candidateData?.candidate?.gender
                          ? candidateData?.candidate?.gender?.charAt(0)?.toUpperCase() + candidateData?.candidate?.gender?.substring(1)
                          : "----"}
                      </p>
                    ) : (
                      <p className="value text_blur">
                        {candidateData?.candidate?.gender
                          ? replaceString(candidateData?.candidate?.gender)
                          : "----"}
                      </p>
                    )}
                  </div>
                </Col>
                <Col xs={11} md={24}>
                  <div className="detail_box">
                    <p className="item">Ethnicity</p>

                    {!isHidden ? (
                      <p className="value">
                        {candidateData?.candidate?.ethnicity?.name || "----"}
                      </p>
                    ) : (
                      <p className="value text_blur">
                        {candidateData?.candidate?.ethnicity?.name
                          ? replaceString(candidateData?.candidate?.ethnicity?.name)
                          : "----"}
                      </p>
                    )}
                  </div>
                </Col>
                {candidateData?.candidate?.nextOfKinRelation?.name && <Col xs={11} md={24}>
                  <div className="detail_box">
                    <p className="item">Next of kin</p>

                    {!isHidden ? (
                      <p className="value">
                        {candidateData?.candidate?.nextOfKinName || candidateData?.candidate?.nextOfKinRelation?.name || candidateData?.candidate?.nextOfKinEmail
                          ? `${candidateData?.candidate?.nextOfKinName || ""}${candidateData?.candidate?.nextOfKinRelation?.name ? `(${candidateData?.candidate?.nextOfKinRelation?.name})` : ""}${candidateData?.candidate?.nextOfKinEmail ? `\n\n${candidateData?.candidate?.nextOfKinEmail}` : ""}`
                          : "----"}
                      </p>
                    ) : (
                      <p className="value text_blur">
                        {candidateData?.candidate?.nextOfKinName || candidateData?.candidate?.nextOfKinRelation?.name || candidateData?.candidate?.nextOfKinEmail
                          ? replaceString(`${candidateData?.candidate?.nextOfKinName || ""} (${candidateData?.candidate?.nextOfKinRelation?.name || ""})\n\n${candidateData?.candidate?.nextOfKinEmail || ""}`)
                          : "----"}
                      </p>
                    )}
                  </div>
                </Col>}
                 
                <Col xs={11} md={24}>
                  <div className="detail_box">
                    <p className="item">Availability</p>
                    {candidateData?.candidate?.isAvailable ? (
                      <p className="value">I’m available for work</p>
                    ) : (
                      <p className="value">I’m not available for work</p>
                    )}
                  </div>
                </Col>
                <Col xs={11} md={24}>
                  <div className="detail_box">
                    <p className="item">Start / Notice</p>

                      <p className="value">
                        {candidateData?.candidate?.availabilityDetails?.name || "----"}
                      </p>
                   
                  </div>
                </Col>
           
                
                
              </Row>
            </div>
          </Col>

          <Col xs={24} md={17}>
            <div className="professional_detail_container">
                              <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    position: "sticky",
                    top: 0,
                    zIndex: 9999,
                    gap: "16px",
                    flexWrap: "wrap",
                  }}
                >
                <div className="radioButtons" style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <Radio.Group
                    defaultValue={type}
                    onChange={(e) => setType(e?.target?.value)}
                  >
                    <Radio.Button value="PE">
                      Professional Experience
                    </Radio.Button>
                    <Radio.Button value="QS">Qualifications</Radio.Button>
                    <Radio.Button value="OD">Other Details</Radio.Button>
                  </Radio.Group>
                  {(props?.search ||
                    previousCurrentPage === "search" ||
                    withDrawlCandidate === "yes") && (
                    <Button
                      className="applicant-profile-chat-btn"
                      onClick={() => setChatDrawerOpen(true)}
                    >
                      Chat
                    </Button>
                  )}
                  {!isHidden && (
                    <Tooltip
                      overlayStyle={{ zIndex: 9999999 }}
                      title="Download a copy of candidates uploaded documents"
                    >
                      <div>
                        <Button
                          onClick={DownloadDocs}
                          style={{
                            backgroundColor: "#071135",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          <DownloadOutlined />
                          <span> Export Files</span>
                        </Button>
                      </div>
                    </Tooltip>
                  )}
                </div>
                {/* Removed previous right-side column-reverse container */}
                <div style={{ display: "none" }}>
                  {!isHidden && (
                    <Tooltip
                      overlayStyle={{ zIndex: 9999999 }}
                      title="Download a copy of candidates uploaded documents"
                    >
                      <div>
                        <Button
                          onClick={DownloadDocs}
                          style={{
                            backgroundColor: "#071135",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          <DownloadOutlined />
                          <span> Export Files</span>
                        </Button>
                      </div>
                    </Tooltip>
                  )}
                  <div style={{ marginBottom: !isHidden ? 8 : 0 }}>
                    <Button className="ask-btn" loading={askLoading} onClick={handleAsk}>
                      <span className="ask-icon" >
                       <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12.5 13V9M12.5 9H8.5M12.5 9L6.5 15M16 10L18.5768 8.45392C19.3699 7.97803 19.7665 7.74009 20.0928 7.77051C20.3773 7.79703 20.6369 7.944 20.806 8.17433C21 8.43848 21 8.90095 21 9.8259V14.1741C21 15.099 21 15.5615 20.806 15.8257C20.6369 16.056 20.3773 16.203 20.0928 16.2295C19.7665 16.2599 19.3699 16.022 18.5768 15.5461L16 14M6.2 18H12.8C13.9201 18 14.4802 18 14.908 17.782C15.2843 17.5903 15.5903 17.2843 15.782 16.908C16 16.4802 16 15.9201 16 14.8V8.4C16 7.55992 16 7.13988 15.8365 6.81901C15.6927 6.53677 15.4632 6.3073 15.181 6.16349C14.8601 6 14.4401 6 13.6 6H5.4C4.55992 6 4.13988 6 3.81901 6.16349C3.53677 6.3073 3.3073 6.53677 3.16349 6.81901C3 7.13988 3 7.55992 3 8.4V14.8C3 15.9201 3 16.4802 3.21799 16.908C3.40973 17.2843 3.71569 17.5903 4.09202 17.782C4.51984 18 5.07989 18 6.2 18Z" stroke="#071135" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      </span>
                      <span style={{marginBottom:"-5px"}}>Ask</span>
                    </Button>
                  </div>
                </div>
              </div>
              <div
                className="professional_detail_content"
                style={{ marginTop: "5vh" }}
              >
                {type === "PE" && (
                  <div className="professional_experience_container">
                    <div className="professional_summary_box">
                    
                      <div>
                        {candidateData?.candidate?.introVideo && <p className="title"></p> }
                        
        {candidateData?.candidate?.introVideo &&    <>
        
      {/* Thumbnail card */}



      <Col
        xs={24}
        md={12}
        style={{
          width: "280px",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          background: "#f8f9ff",
          padding: "0px",
          marginBottom: "15px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          height: "120px",
        }}
        onClick={handleOpen}
      >
        <img
          src={thumbnail}
          alt="Intro Video"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        {/* Play button overlay */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: 0,
              height: 0,
              borderLeft: "16px solid #fff",
              borderTop: "10px solid transparent",
              borderBottom: "10px solid transparent",
            }}
          />
        </div>
      </Col>

      {/* Modal with video */}
      <Modal
        title="Intro Video"
        open={isModalOpen}
        onCancel={handleClose}
        footer={null}
        centered
        getContainer={document.body}
        width={720}
        bodyStyle={{ padding: 0 }}
        destroyOnClose={true}
        zIndex={9999}
      >
        <video
          src={candidateData?.candidate?.introVideo}
          playing={true}
          autoPlay={true}
          controls
          width="100%"
          height="400px"
        />
      </Modal>
    </>
    }               
                   {!candidateData?.candidate?.introVideo && <div>
                     <Tooltip title={"Request the candidate to upload an introduction video."} zIndex={99999}>
                    <Button className="ask-btn" loading={askLoading} onClick={handleAsk}>
                      <span className="ask-icon" style={{marginTop:"10px"}}>
                     <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M12.5 13V9M12.5 9H8.5M12.5 9L6.5 15M16 10L18.5768 8.45392C19.3699 7.97803 19.7665 7.74009 20.0928 7.77051C20.3773 7.79703 20.6369 7.944 20.806 8.17433C21 8.43848 21 8.90095 21 9.8259V14.1741C21 15.099 21 15.5615 20.806 15.8257C20.6369 16.056 20.3773 16.203 20.0928 16.2295C19.7665 16.2599 19.3699 16.022 18.5768 15.5461L16 14M6.2 18H12.8C13.9201 18 14.4802 18 14.908 17.782C15.2843 17.5903 15.5903 17.2843 15.782 16.908C16 16.4802 16 15.9201 16 14.8V8.4C16 7.55992 16 7.13988 15.8365 6.81901C15.6927 6.53677 15.4632 6.3073 15.181 6.16349C14.8601 6 14.4401 6 13.6 6H5.4C4.55992 6 4.13988 6 3.81901 6.16349C3.53677 6.3073 3.3073 6.53677 3.16349 6.81901C3 7.13988 3 7.55992 3 8.4V14.8C3 15.9201 3 16.4802 3.21799 16.908C3.40973 17.2843 3.71569 17.5903 4.09202 17.782C4.51984 18 5.07989 18 6.2 18Z" stroke="#071135" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      </span>
                     
                      <span style={{marginBottom:"-5px"}}>Ask</span>
                     
                    </Button>
                     </Tooltip>
                  </div> }     
                    <p className="title" style={{marginTop:"15px"}}>Profile Summary Description</p>
                      <p className="desc">
                        {candidateData?.candidate?.profileSummary}
                      </p>
   
                        {/* <video src={candidateData?.candidate?.introVideo} autoPlay={true} height={90} width={90} controls/> */}
                        {candidateData?.candidate?.resume?.[0]?.resume ? (
                          <>
                            <p className="title">Resume</p>
                            <Row>
                              <Col xs={24} md={12}>
                                <DocumentBox
                                  docLink={
                                    candidateData?.candidate?.resume[0]?.resume
                                  }
                                  updatedDate={
                                    candidateData?.candidate?.resume[0]?.updatedAt
                                  }
                                  isHidden={isHidden}
                                />
                              </Col>
                            </Row>
                          </>
                        ) : null}
                      </div>
                    </div>
                    {USE_GROUPED_JOB_EXPERIENCE ? (
                      <div className="linkedinExperienceList">
                        <p className="linkedinExperienceHeading">Experience</p>
                        {groupExperiences(
                          candidateData?.candidate?.experiences
                        ).map((group) => (
                          <JobPositionCardGrouped
                            key={group?.parent?._id || group?.parent?.id}
                            data={group.parent}
                            childExperiences={group.children}
                            isHidden={isHidden}
                          />
                        ))}
                      </div>
                    ) : (
                      <Row gutter={[18, 18]}>
                        {(candidateData?.candidate?.experiences || []).map(
                          (expData) => (
                            <Col
                              xs={24}
                              md={24}
                              key={expData?._id || expData?.id}
                            >
                              <JobPositionCard
                                data={expData}
                                isHidden={isHidden}
                              />
                            </Col>
                          )
                        )}
                      </Row>
                    )}
                  </div>
                )}
                {type === "QS" && (
                  <>
                    {candidateData?.candidate?.qualifications.map((qual) => (
                      <div className="qualification_container mb-20">
                        <div className="qualification_summary_box">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <p className="title" style={{ marginBottom: 0, display: "inline-flex", alignItems: "center", gap: "8px" }}>
                              {qual?.qualificationType?.name}
                              {qual?.isValidate && <img src={CheckMark} />}
                            </p>
                            {hasAllPermissions && (
                              <Tooltip title="Send manual notification">
                                <img
                                  style={{ width: "25px", cursor: "pointer" }}
                                  src="/telegramIcon.png"
                                  alt="send notification"
                                  onClick={() => {
                                    setTicketType("qualification");
                                    setTicketId(qual?._id || qual?.id);
                                    setNotificationHeading(qual?.qualificationType?.name || "");
                                    setNotify(true);
                                  }}
                                />
                              </Tooltip>
                            )}
                          </div>
                          <Row
                            gutter={24}
                            className="civil-certificate"
                            style={{ marginTop: "10px" }}
                          >
                            <Col
                              xs={24}
                              md={qual?.uploadedDocumentBack ? 7 : 14}
                            >
                              <DocumentBox
                                docLink={qual?.uploadedDocument}
                                updatedDate={qual?.issueDate}
                                isHidden={isHidden}
                              />
                            </Col>
                            {qual?.uploadedDocumentBack && (
                              <Col xs={24} md={7}>
                                <DocumentBox
                                  docLink={qual?.uploadedDocumentBack}
                                  updatedDate={qual?.issueDate}
                                  isHidden={isHidden}
                                />
                              </Col>
                            )}

                            <Col
                              xs={24}
                              md={10}
                              style={{ marginBottom: "10px" }}
                            >
                              <Row justify={"space-between"}>
                                <Col span={12}>
                                  <p className="item">Issue Date</p>
                                  <p className="value">
                                    {qual?.issueDate
                                      ? moment(qual?.issueDate).format("DD MMM YYYY")
                                      : "----"}
                                  </p>
                                </Col>
                                <Col span={12}>
                                  <p className="item">Expiry Date</p>
                                  <p className="value">
                                    {qual?.expiryDate
                                      ? moment(qual?.expiryDate).format("DD MMM YYYY")
                                      : "----"}
                                  </p>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row gutter={15} style={{ marginTop: "20px" }}>
                            <Col xs={8}>
                              <p className="item">Member No./ID</p>
                              {!isHidden ? (
                                  <p className="value">{qual?.memberId || "----"}</p>
                              ) : (
                                <p className="value text_blur">
                                  {replaceString(qual?.memberId)}
                                </p>
                              )}
                            </Col>
                            <Col xs={8}>
                              <p className="item">State/Country</p>
                              <p className="value">{qual?.stateOrCountry || "----"}</p>
                            </Col>
                            <Col xs={8}>
                              <p className="item">
                                Licence Type/Class/Category
                              </p>
                              {qual?.licenceType && qual?.licenceType?.length > 0 ? (
                                qual?.licenceType?.map((item, index) => (
                                  <p key={index} className="value">
                                    {item?.name || "----"}{index !== qual?.licenceType?.length - 1 ? "," : ""}
                                  </p>
                                ))
                              ) : (
                                <p className="value">----</p>
                              )}
                            </Col>
                          </Row>
                        </div>

                        {(qual?.hasSOA || qual?.hasVOC) && (
                          <div className="qualification_detail_box ">
                            {qual?.hasSOA && (
                              <div>
                                <p
                                  className="title cursor_pointer justify_space"
                                  onClick={handleStatementOfAttainment}
                                >
                                  Statement of Attainment{" "}
                                  {!soaOpen ? <DownOutlined /> : <UpOutlined />}
                                </p>

                                {soaOpen && (
                                  <Row gutter={24} className="sm-row-reverse">
                                    <Col xs={24} md={14} className="sm-mt-16">
                                      <DocumentBox
                                        docLink={qual?.SOADocument}
                                        isHidden={isHidden}
                                      />
                                    </Col>
                                    <Col xs={24} md={10}>
                                      <p className="item">Issue Date</p>
                                      <p className="value">
                                        {qual?.SOAIssueDate
                                          ? moment(qual?.SOAIssueDate).format("DD MMM YYYY")
                                          : "----"}
                                      </p>
                                    </Col>
                                  </Row>
                                )}
                              </div>
                            )}
                            {qual?.hasSOA && (
                              <Divider className="horizontalDivider" />
                            )}
                            {qual?.hasVOC && (
                              <div>
                                <p
                                  className="title cursor_pointer justify_space"
                                  onClick={handleVOC}
                                >
                                  Verification of Competency{" "}
                                  {!vocOpen ? <DownOutlined /> : <UpOutlined />}
                                </p>
                                {vocOpen && (
                                  <Row gutter={24} className="sm-row-reverse">
                                    <Col xs={24} md={14} className="sm-mt-16">
                                      <DocumentBox
                                        docLink={qual?.VOCDocument}
                                        isHidden={isHidden}
                                      />
                                    </Col>
                                    <Col xs={24} md={10}>
                                      <Row justify={"space-between"}>
                                        <Col span={12}>
                                          <p className="item">
                                            {" "}
                                            Verification Type
                                          </p>
                                          <p className="value">
                                            {qual?.VOCType?.name || "----"}
                                          </p>
                                        </Col>
                                        <Col span={12}>
                                          <p className="item">Issue Date </p>
                                          <p className="value">
                                            {qual?.VOCIssueDate
                                              ? moment(qual?.VOCIssueDate).format("DD MMM YYYY")
                                              : "----"}
                                          </p>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                )}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </>
                )}
                {type === "OD" && (
                  <div className="other_detail_container">
                    <div className="citizen_container">
                      <div className="titleBox">
                        {citizen === "australian"
                          ? "Australian / New Zealand Citizen"
                          : "Non - Australian Citizen"}
                      </div>
                      <div className="detail-container">
                        <>
                          {candidateData?.candidate?.documents?.map((doc) => (
                            <div style={{ padding: "20px 0" }}>
                              <div className="mt-30" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <p className="title" style={{ marginBottom: 0, display: "inline-flex", alignItems: "center", gap: "8px" }}>
                                  {doc?.documentType?.name}
                                  {doc?.isVerfied && <img src={CheckMark} />}
                                </p>
                                {hasAllPermissions && (
                                  <Tooltip title="Send manual notification">
                                    <img
                                      style={{ width: "25px", cursor: "pointer" }}
                                      src="/telegramIcon.png"
                                      alt="send notification"
                                      onClick={() => {
                                        setTicketType("otherDetails");
                                        setTicketId(doc?._id || doc?.id);
                                        setNotificationHeading(doc?.documentType?.name || "");
                                        setNotify(true);
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </div>
                              <Row gutter={24}>
                                <Col
                                  xs={24}
                                  sm={doc?.documentBack ? 7 : 14}
                                  style={{ marginBottom: "10px" }}
                                >
                                  <DocumentBox
                                    docLink={doc?.document}
                                    isHidden={isHidden}
                                  />
                                </Col>
                                {doc?.documentBack && (
                                  <Col
                                    xs={24}
                                    sm={7}
                                    style={{ marginBottom: "10px" }}
                                  >
                                    <DocumentBox
                                      docLink={doc?.documentBack}
                                      isHidden={isHidden}
                                    />
                                  </Col>
                                )}
                                <Col xs={24} sm={10}>
                                  <Row gutter={15}>
                                    <Col xs={12}>
                                      <p className="item">
                                        {doc.documentType.name === "Passport"
                                          ? "Nationality"
                                          : doc.documentType.name ===
                                            "Proof of Age/Photo Card"
                                          ? "State"
                                          : doc.documentType.name === "VISA"
                                          ? "Visa Type Number"
                                          : doc.documentType.name ===
                                            "Driver Licence"
                                          ? "State"
                                          : "ID Number"}
                                      </p>
                                      <p
                                        className="value"
                                        style={{
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {doc.documentType.name === "Passport"
                                          ? doc?.documentData?.nationality
                                              ? doc?.documentData?.nationality?.substring(0, 1)?.toUpperCase() + doc?.documentData?.nationality?.substring(1)
                                              : "----"
                                          : doc.documentType.name === "Proof of Age/Photo Card"
                                          ? (doc?.documentData?.state && typeof doc?.documentData?.state === 'object' && doc?.documentData?.state?.name)
                                            ? doc?.documentData?.state?.name
                                            : (doc?.documentData?.state && typeof doc?.documentData?.state === 'string')
                                            ? doc?.documentData?.state
                                            : "----"
                                          : doc.documentType.name === "VISA"
                                          ? doc?.documentData?.visaTypeNo?.name || "----"
                                          : doc?.documentType?.name === "Driver Licence"
                                          ? doc?.documentData?.stateDL || doc?.documentData?.state || "----"
                                          : doc?.documentData?.idNumber || "----"}
                                      </p>
                                    </Col>
                                    <Col xs={12}>
                                      <p className="item">
                                        {doc.documentType.name === "Passport"
                                          ? "Passport Number"
                                          : doc.documentType.name ===
                                            "Driver Licence"
                                          ? "Licence Number"
                                          : doc.documentType.name === "VISA"
                                          ? "Grant Number"
                                          : "ID Number"}
                                      </p>
                                      {doc.documentType.name === "Passport" ? (
                                        !isHidden ? (
                                          <p className="value">
                                            {doc?.documentData?.passportNumber || "----"}
                                          </p>
                                        ) : (
                                          <p className="value text_blur">
                                            {doc?.documentData?.passportNumber
                                              ? replaceString(doc?.documentData?.passportNumber)
                                              : "----"}
                                          </p>
                                        )
                                      ) : doc.documentType.name === "Driver Licence" ? (
                                        <p className="value">
                                          {doc?.documentData?.licenceNumber || doc?.documentData?.licenseNumber || "----"}
                                        </p>
                                      ) : doc.documentType.name === "VISA" ? (
                                        !isHidden ? (
                                          <p className="value">
                                            {doc?.documentData?.grantNo || "----"}
                                          </p>
                                        ) : (
                                          <p className="value text_blur">
                                            {doc?.documentData?.grantNo
                                              ? replaceString(doc?.documentData?.grantNo)
                                              : "----"}
                                          </p>
                                        )
                                      ) : doc.documentType.name === "Proof of Age/Photo Card" ? (
                                        !isHidden ? (
                                          <p className="value">
                                            {doc?.documentData?.idNumber || "----"}
                                          </p>
                                        ) : (
                                          <p className="value text_blur">
                                            {doc?.documentData?.idNumber
                                              ? replaceString(doc?.documentData?.idNumber)
                                              : "----"}
                                          </p>
                                        )
                                      ) : (
                                        <p className="value">
                                          {doc?.documentData?.idNumber || "----"}
                                        </p>
                                      )}
                                    </Col>
                                  </Row>
                                  <Row gutter={15}>
                                    <Col span={12}>
                                      {doc?.documentType?.name ===
                                        "Driver Licence" && (
                                        <div className="mt-16">
                                          <p className="item">Class</p>
                                          <p className="value">
                                            {Array.isArray(doc?.documentData?.class) &&
                                            doc?.documentData?.class?.length > 0
                                              ? doc?.documentData?.class?.map(
                                                  (e) => {
                                                    return `${e} `;
                                                  }
                                                )
                                              : "----"}
                                          </p>
                                        </div>
                                      )}
                                      {doc?.documentType?.name === "VISA" ? (
                                        <div className="mt-16">
                                          <p className="item">Issue Date</p>
                                          <p className="value">
                                            {doc?.documentData?.issueDate
                                              ? moment(doc?.documentData?.issueDate).format("DD MMM YYYY")
                                              : "----"}
                                          </p>
                                        </div>
                                      ) : (
                                        <div className="mt-16">
                                          <p className="item">Expiry Date</p>
                                          <p className="value">
                                            {doc?.documentData?.expiryDate
                                              ? moment(doc?.documentData?.expiryDate).format("DD MMM YYYY")
                                              : "----"}
                                          </p>
                                        </div>
                                      )}
                                    </Col>
                                    <Col span={12}>
                                      {doc?.documentType?.name ===
                                        "Driver Licence" && (
                                        <div className="mt-16">
                                          <p className="item">Conditions</p>
                                          <p className="value">
                                            {Array.isArray(doc?.documentData?.conditions) &&
                                            doc?.documentData?.conditions?.length > 0
                                              ? doc?.documentData?.conditions?.map(
                                                  (e) => {
                                                    return `${e} `;
                                                  }
                                                )
                                              : "----"}
                                          </p>
                                        </div>
                                      )}
                                      {doc?.documentType?.name === "VISA" && (
                                        <div className="mt-16">
                                          <p className="item">Expiry Date</p>
                                          <p className="value">
                                            {doc?.documentData?.expiryDate
                                              ? moment(doc?.documentData?.expiryDate).format("DD MMM YYYY")
                                              : "----"}
                                          </p>
                                        </div>
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                          ))}
                        </>
                      </div>
                    </div>

                    <div className="additional_detail_container">
                      <div className="titleBox">
                        Additional Personal Details
                      </div>
                      <div className="detail-container">
                        <Row gutter={16}>
                          <Col span={8}>
                            <p className="item">Tax File Number (TFN)</p>
                            {!isHidden ? (
                              <p className="value">
                                {candidateData?.candidate?.otherDetails?.[0]?.tfnNo || "----"}
                              </p>
                            ) : (
                              <p className="value text_blur">
                                {candidateData?.candidate?.otherDetails?.[0]?.tfnNo
                                  ? replaceString(candidateData?.candidate?.otherDetails[0]?.tfnNo)
                                  : "----"}
                              </p>
                            )}
                          </Col>
                          <Col span={8}>
                            <p className="item">USI No.</p>
                            {!isHidden ? (
                              <p className="value">
                                {candidateData?.candidate?.otherDetails?.[0]?.usiNo || "----"}
                              </p>
                            ) : (
                              <p className="value text_blur">
                                {candidateData?.candidate?.otherDetails?.[0]?.usiNo
                                  ? replaceString(candidateData?.candidate?.otherDetails[0]?.usiNo)
                                  : "----"}
                              </p>
                            )}
                          </Col>
                        </Row>
                        <Divider className="horizontalDivider" />
                        <div>
                          <p className="title">Superannuation</p>
                          <Row gutter={16}>
                            <Col span={8}>
                              <p className="item">Fund Name</p>
                              {!isHidden ? (
                                <p className="value">
                                  {candidateData?.candidate?.otherDetails?.[0]?.superannuationDetails?.fundName?.name || "----"}
                                </p>
                              ) : (
                                <p className="value text_blur">
                                  {candidateData?.candidate?.otherDetails?.[0]?.superannuationDetails?.fundName?.name
                                    ? replaceString(candidateData?.candidate?.otherDetails[0]?.superannuationDetails?.fundName?.name)
                                    : "----"}
                                </p>
                              )}
                            </Col>
                            <Col span={8}>
                              <p className="item">Fund USI/ABN</p>
                              {!isHidden ? (
                                <p className="value">
                                  {candidateData?.candidate?.otherDetails?.[0]?.superannuationDetails?.fundUsiAbn?.name || candidateData?.candidate?.otherDetails?.[0]?.superannuationDetails?.fundUsiAbn || "----"}
                                </p>
                              ) : (
                                <p className="value text_blur">
                                  {candidateData?.candidate?.otherDetails?.[0]?.superannuationDetails?.fundUsiAbn?.name || candidateData?.candidate?.otherDetails?.[0]?.superannuationDetails?.fundUsiAbn
                                    ? replaceString(candidateData?.candidate?.otherDetails[0]?.superannuationDetails?.fundUsiAbn?.name || candidateData?.candidate?.otherDetails[0]?.superannuationDetails?.fundUsiAbn)
                                    : "----"}
                                </p>
                              )}
                            </Col>
                            <Col span={8}>
                              <p className="item">Member Number</p>
                              {!isHidden ? (
                                <p className="value">
                                  {candidateData?.candidate?.otherDetails?.[0]?.superannuationDetails?.memberNumber || "----"}
                                </p>
                              ) : (
                                <p className="value text_blur">
                                  {candidateData?.candidate?.otherDetails?.[0]?.superannuationDetails?.memberNumber
                                    ? replaceString(candidateData?.candidate?.otherDetails[0]?.superannuationDetails?.memberNumber)
                                    : "----"}
                                </p>
                              )}
                            </Col>
                          </Row>
                        </div>
                        <Divider className="horizontalDivider" />
                        <div>
                          <p className="title">Long Service Leave</p>
                          <Row gutter={16}>
                            {candidateData?.candidate?.otherDetails?.[0]?.lslDetails && 
                             candidateData?.candidate?.otherDetails?.[0]?.lslDetails?.length > 0 ? (
                              candidateData?.candidate?.otherDetails[0]?.lslDetails.map(
                              (item, index) => {
                                return (
                                    <React.Fragment key={index}>
                                    <Col
                                      xs={12}
                                      md={8}
                                      style={{
                                        marginTop: index !== 0 ? "12px" : "0px",
                                      }}
                                    >
                                      <p className="item">State</p>
                                      {!isHidden ? (
                                        <p className="value">
                                          {item?.state?.name || "----"}
                                        </p>
                                      ) : (
                                        <p className="value text_blur">
                                          {item?.state?.name
                                            ? replaceString(item?.state?.name)
                                            : "----"}
                                        </p>
                                      )}
                                    </Col>

                                    <Col
                                      xs={12}
                                      md={16}
                                      style={{
                                        marginTop: index !== 0 ? "12px" : "0px",
                                      }}
                                    >
                                      <p className="item">Member Number</p>
                                      {!isHidden ? (
                                        <p className="value">
                                          {item?.memberNumber || "----"}
                                        </p>
                                      ) : (
                                        <p className="value text_blur">
                                          {item?.memberNumber
                                            ? replaceString(item?.memberNumber)
                                            : "----"}
                                        </p>
                                      )}
                                    </Col>
                                    </React.Fragment>
                                );
                              }
                              )
                            ) : (
                              <>
                                <Col xs={12} md={8}>
                                  <p className="item">State</p>
                                  <p className="value">----</p>
                                </Col>
                                <Col xs={12} md={16}>
                                  <p className="item">Member Number</p>
                                  <p className="value">----</p>
                                </Col>
                              </>
                            )}
                          </Row>
                        </div>
                            <Divider className="horizontalDivider" />
                            <div>
                              <p className="title">PPE Details</p>
                              <Row gutter={16}>
                                <Col xs={8} md={8}>
                                  <p className="item">Shirt</p>
                                  <p className="value">
                                    {candidateData?.candidate?.otherDetails?.[0]?.ppeDetails?.shirt?.name || "----"}
                                  </p>
                                </Col>
                                <Col xs={8} md={8}>
                                  <p className="item">Pants</p>
                                  <p className="value">
                                    {candidateData?.candidate?.otherDetails?.[0]?.ppeDetails?.pants?.name || "----"}
                                  </p>
                                </Col>
                                <Col xs={8} md={8}>
                                  <p className="item">Boots</p>
                                  <p className="value">
                                    {candidateData?.candidate?.otherDetails?.[0]?.ppeDetails?.boots?.name || "----"}
                                  </p>
                                </Col>
                              </Row>
                            </div>
                        <Divider className="horizontalDivider" />
                        <div>
                          <p className="title">Travel Details</p>
                          <Row gutter={16}>
                            <Col xs={12} md={8}>
                              <p className="item">Preferred Airline</p>
                              <p className="value">
                                {candidateData?.candidate?.otherDetails?.[0]?.travelDetails?.preferredAirline || "----"}
                              </p>
                            </Col>

                            <Col xs={12} md={8}>
                              <p className="item">Frequent Flyer Number</p>
                              <p className="value">
                                {candidateData?.candidate?.otherDetails?.[0]?.travelDetails?.frequentFlyerNumber || "----"}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                      <div className="clearance_box">
                      {/* Police Clearance Section - Only show when data exists */}
                      {candidateData?.candidate?.otherDetails?.[0]?.hasPoliceClearance && (
                        <>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <p className="title" style={{ marginBottom: 0, display: "inline-flex", alignItems: "center", gap: "8px" }}>
                                Police Clearance
                          {candidateData?.candidate?.otherDetails?.[0]
                                  ?.policeClearanceDetails?.isVerified && (
                                  <img src={CheckMark} />
                                )}
                              </p>
                        {hasAllPermissions && (
                                <Tooltip title="Send manual notification">
                                  <img
                                    style={{ width: "25px", cursor: "pointer" }}
                                    src="/telegramIcon.png"
                                    alt="send notification"
                                    onClick={() => {
                                      setTicketType("otherDetails");
                                      setTicketId(candidateData?.candidate?.otherDetails[0]?.id);
                                      setNotificationHeading("Police Clearance");
                                      setNotify(true);
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </div>
                            <Row gutter={24}>
                              <Col xs={24} md={14}>
                                <DocumentBox
                                  docLink={
                              candidateData?.candidate?.otherDetails?.[0]
                                ?.policeClearanceDetails?.document || ""
                                  }
                                  updatedDate={
                              candidateData?.candidate?.otherDetails?.[0]
                                ?.policeClearanceDetails?.issueDate || ""
                                  }
                                  isHidden={isHidden}
                                />
                              </Col>
                              <Col xs={24} md={10} className="sm-mt-10">
                                <Row justify={"space-between"}>
                                  <Col span={12}>
                                    <p className="item">Certifying Authority</p>
                                    <p className="value">
                                      {candidateData?.candidate?.otherDetails?.[0]?.policeClearanceDetails?.certifyingAuthority?.name || "----"}
                                    </p>
                                  </Col>
                                  <Col span={12}>
                                    <p className="item">Issue Date </p>
                                    <p className="value">
                                      {candidateData?.candidate?.otherDetails?.[0]?.policeClearanceDetails?.issueDate
                                        ? moment(candidateData?.candidate?.otherDetails[0]?.policeClearanceDetails?.issueDate).format("DD MMM YYYY")
                                        : "----"}
                                    </p>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Divider className="horizontalDivider" />
                        </>
                      )}
                      
                      {/* Medical Assessment Section - Always Show */}
                      {candidateData?.candidate?.medicalAssessment?.length > 0 && 
                       candidateData?.candidate?.medicalAssessment[0]?.medicals?.length > 0 ? (
                          <>
                            {candidateData?.candidate?.medicalAssessment[0]?.medicals?.map(
                              (med, medIndex) => (
                                <div key={medIndex} style={{ marginBottom: medIndex < candidateData?.candidate?.medicalAssessment[0]?.medicals?.length - 1 ? "20px" : "0" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
                                    <p className="title" style={{ marginBottom: 0, display: "inline-flex", alignItems: "center", gap: "8px" }}>
                                    Medical Assessment
                                      {med?.isValidate && <img src={CheckMark} />}
                                    </p>
                                    {hasAllPermissions && (
                                      <Tooltip title="Send manual notification">
                                        <img
                                          style={{ width: "25px", cursor: "pointer" }}
                                          src="/telegramIcon.png"
                                          alt="send notification"
                                          onClick={() => {
                                            setTicketType("otherDetails");
                                            setTicketId(med?._id || med?.id);
                                            setNotificationHeading("Medical Assessment");
                                            setNotify(true);
                                          }}
                                        />
                                      </Tooltip>
                                    )}
                                  </div>
                                  <Row gutter={24} className="mb-5">
                                    <Col xs={24} md={14}>
                                      <DocumentBox
                                        docLink={med?.document}
                                        updatedDate={med?.issueDate}
                                        isHidden={isHidden}
                                      />
                                    </Col>
                                    <Col xs={24} md={10} className="sm-mt-10">
                                      <Row justify={"space-between"}>
                                        <Col span={12}>
                                        <p className="item">Medical Assessment Type</p>
                                          <p className="value">
                                            {med?.medicalAssessment?.name || "----"}
                                          </p>
                                        </Col>
                                        <Col span={12}>
                                          <p className="item">Issue Date </p>
                                          <p className="value">
                                            {med?.issueDate
                                              ? moment(med?.issueDate).format("DD MMM YYYY")
                                              : "----"}
                                          </p>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                  {medIndex < candidateData?.candidate?.medicalAssessment[0]?.medicals?.length - 1 && (
                                    <Divider className="horizontalDivider" />
                                  )}
                                </div>
                              )
                            )}
                          </>
                    ) : null}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
        <UpdateApplicantProfileStatus
          visible={updateStatusModal}
          setVisible={setUpdateStatusModal}
        />
      </div>
      <Modal
        title={"Notification"}
        open={notify}
        onCancel={() => {
          form1.resetFields();
          setTicketType(null);
          setTicketId(null);
          setNotificationHeading("");
          setNotify(false);
        }}
        centered
        getContainer={document.body}
        footer={false}
      >
        <Form 
          form={form1} 
          layout="vertical" 
          onFinish={handleNotify}
        >
          <Row>
            <Col xs={24}>
              {notificationHeading && (
                <div style={{ marginBottom: "16px" }}>
                  <p style={{ margin: 0, fontSize: "16px", fontWeight: "bold", color: "#071135" }}>
                    {notificationHeading}
                  </p>
                </div>
              )}
              <Form.Item name="message">
                <Input className="input" placeholder="Enter message" />
              </Form.Item>
              <Col md={24} className="buttonCol">
                <Form.Item>
                  <Button
                    className="btn"
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    style={{ backgroundColor: "#091647" }}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Col>
          </Row>
        </Form>
      </Modal>
    </SubLayout>
    </>
  );
}

export default ApplicantProfile;
